// 261010 P8b-1 — chip trạng thái (dời nguyên từ FilmWorkflowPage).
import React from 'react';
import { STATE_META } from './workflowBoardUtils';

const Chip: React.FC<{ state: keyof typeof STATE_META }> = ({ state }) => <span className={`wf-chip ${STATE_META[state].tone}`}>{STATE_META[state].label}</span>;

export default Chip;
